import type { ReactNode } from 'react';

import { Box, Tab, Tabs } from '@mui/material';
import { MousePointerClick, Sparkles } from 'lucide-react';

import { SelectionPickerHeader } from '@modules/reports/shared/SelectionPickerHeader';
import { useLocale } from '@shared/hooks/locale';

export const ListingsPicker = ({
  onClose,
  tab,
  onTabChange,
  selectionCount,
  onClear,
  onSave,
  saving,
  children,
}: {
  onClose: () => void;
  tab: 'automatic' | 'manual';
  onTabChange: (tab: 'automatic' | 'manual') => void;
  selectionCount: number;
  onClear: () => void;
  onSave: () => void;
  saving: boolean;
  children: ReactNode;
}) => {
  const { t } = useLocale();
  const tabs = (
    <Tabs
      value={tab}
      onChange={(_, value) => onTabChange(value)}
      sx={theme => ({
        '.MuiButtonBase-root': {
          height: { xs: '48px', md: '64px' },
          minWidth: '0',
        },
        '.MuiTabs-indicator': {
          backgroundColor: (theme.vars ?? theme).palette.primary.main,
          borderRadius: '3px 3px 0 0',
        },
        '.Mui-selected': {
          color: (theme.vars ?? theme).palette.text.primary,
        },
        '.MuiTab-root:not(.Mui-selected)': {
          fontWeight: '500',
        },
      })}
    >
      <Tab
        icon={<MousePointerClick size={18} />}
        iconPosition="start"
        label={t('Manual filtering')}
        value="manual"
      />
      <Tab
        icon={<Sparkles size={18} />}
        iconPosition="start"
        label={t('Automatic algorithm')}
        value="automatic"
      />
    </Tabs>
  );

  return (
    <>
      <SelectionPickerHeader
        title={t('Listings')}
        tabs={tabs}
        onClose={onClose}
        selectionCount={selectionCount}
        onClear={onClear}
        onSave={onSave}
        saving={saving}
      />
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
    </>
  );
};
